import { useAuthStore } from '@/stores/auth';
import type { Role } from '@/types/api';

export function useAuth() {
  const user = useAuthStore((s) => s.user);
  const isInitializing = useAuthStore((s) => s.isInitializing);
  const clear = useAuthStore((s) => s.clear);
  const setSession = useAuthStore((s) => s.setSession);
  const setUser = useAuthStore((s) => s.setUser);
  const activeOrgId = useAuthStore((s) => s.activeOrgId);
  const organizations = useAuthStore((s) => s.organizations);
  const setActiveOrg = useAuthStore((s) => s.setActiveOrg);

  const hasRole = (roles: Role | Role[] | undefined): boolean => {
    if (!roles) return true;
    if (!user) return false;
    const list = Array.isArray(roles) ? roles : [roles];
    return list.includes(user.role);
  };

  return {
    user,
    isAuthenticated: !!user,
    isInitializing,
    hasRole,
    logout: clear,
    setSession,
    setUser,
    activeOrgId,
    organizations,
    setActiveOrg,
  };
}
